// bgColor and fontColor passed as a prop to the Component
// should be respresentation of colors used in theme.js and be included there
//
// <Button bgColor="blue_500" fontColor="white"

import styled from "styled-components"
import Pointable from "./Pointable"
import Text from "./Text"

interface LinkProps {
  disabled?: boolean
}
const Link = styled(Pointable).attrs({ as: Text })<LinkProps>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  ${({ disabled, theme }) => disabled && `color: ${theme.gray_400};`}
`
export default Link
